// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__MPtUA","item":"PaymentsMobile_item__2z5Qi","label":"PaymentsMobile_label__1X8xq","amount":"PaymentsMobile_amount__6i0KN"};